import React from 'react'

export default function Marquee() {
  return (
    // eslint-disable-next-line
    <marquee  direction="left" id="Headmarquee">
Submission open for Poster Presentations. Email <a href='mailto:icspt@iitp.ac.in' style={{textDecoration:'none', fontSize:'24px',fontWeight:'bolder', color:'white'}}>icspt@iitp.ac.in</a> for more details.
</marquee>
  )
}
